module.exports = __webpack_public_path__ + "static/media/License.163307dc.svg";